import React from "react";

import { notifier } from "../../shared/helpers/airbrake";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
      errorInfo: null,
      summary: props.summary || "Sorry, something went wrong"
    };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
    const env = document.querySelector('meta[name="server-environment"]');
    const { componentStack } = errorInfo;

    if (env) {
      this.setState({
        env: env.getAttribute("content")
      })
    }

    notifier.notify({
      error,
      params: {
        info: {
          componentStack: componentStack.split(/\s{2,}/).filter(Boolean)
        }
      }
    });
  }

  renderDetails() {
    const { state } = this;

    return (
      <details>
        <summary>{state.summary}</summary>
        <p style={{ whiteSpace: "pre-wrap" }}>
          {state.error.toString()}
          {state.errorInfo.componentStack}
        </p>
      </details>
    );
  }

  renderError() {
    const { state } = this;

    return /development|staging/.test(state.env)
      ? this.renderDetails()
      : (<p>{state.summary}</p>);
  }

  render() {
    const { state } = this;

    return state.error ? this.renderError() : this.props.children;
  }
}

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./components/shared/ErrorBoundary.jsx